import {useDispatch} from 'react-redux'
import {useMemo,useState,useEffect} from 'react'
import Event from './Event'
import useWindowSize from '../../hooks/useWindowSize'

import useCurrentUser from '../../hooks/useCurrentUser'
import {useGymTrainers,useClients} from '../users/hooks'

import css from './Styles.module.css'

import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'

import Select from 'react-select'

import { Calendar, momentLocalizer } from 'react-big-calendar'
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop"
import moment from 'moment'
import { dateToTimeObj, dateToYMD, dateToAPIStandard,getTimeString } from '../../util/datetime'

import Creator from './Creator'
import Editor from './Editor'
import Viewer from './Viewer'

import EventCopyModal from '../EventList/CopyModal/CopyModal'

import {
	getAllEventsInRange,
	editCalendarEvent,
	setRange
} from './slice'

import {
	useSetCreator,
	useSetViewer,
	useSetEditor,
	useEvents,
} from './hooks'


const DragAndDropCalendar = withDragAndDrop(Calendar)

const localizer = momentLocalizer(moment)

function nDaysAgo(inputDate,n) {
    // Parse the input date
    var date = new Date(inputDate);

    // Subtract n days
    date.setDate(date.getDate() - n);

    // Format the date in 'YYYY-MM-DD' format
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString().padStart(2, '0'); // Months are 0-based in JavaScript
    var day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}


const eventPropGetter = (event) => {

	let color;
	switch (event.event_type) {
		case 'workout':
			color = '#B6F0EE'
			break
		case 'nutrition':
			color = 'rgb(255 194 119)'
			break
		case 'task':
			color = 'rgb(177 255 105)'
			break
		case 'not_available':
			color = 'grey'
			break
		case "personal":
			color = '#e0e0e0'
			break
		case "group_session":
			color = "#b8a6f7"
			break
		case "meeting":
			color = '#ffeccf'
			break
		case "closed":
			color = '#6e6e6e'
			break
		case "notes":
			color= "#fdfdfd"
			break
		case "semi_private":
			color = '#03a9fc'
			break
		default:
			color = '#9ef0a8'
	}

	if (event.status == "2") {
		color = "#f0a89e"
	}
	// if its a requested appointment 
	color = event.status == "0" ? 'rgb(249 230 160)' : color;

	const style = {
		backgroundColor: color,
	}

	return {style}

}

const Legend = ()=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	return (
		<div style={{ fontSize: "12.8px" }} className="d-flex flex-wrap">
			<div className="mt-2 mr-3">
				<i className="fas fa-circle mr-1" style={{ color: 'rgb(103 209 206)' }}>
				</i>Workouts | <i className="fas fa-circle mr-1" style={{ color: 'rgb(173 247 0)' }}>
				</i>Tasks | <i className="fas fa-circle mr-1" style={{ color: 'rgb(255 156 33)' }}>
				</i>Nutrition | <i className="fas fa-circle mr-1" style={{ color: 'rgb(178, 158, 247)' }}>
				</i> Class | <i className="fas fa-circle mr-1" style={{ color: '#ffeccf' }}>
				</i> Meeting | <i className="fas fa-circle mr-1" style={{ color: '#03a9fc' }}></i> Semi-private
			</div>

			<div style={{ fontSize: "12.8px" }} className="mt-2">
				<i className="fas fa-circle mr-1" style={{ color: 'rgb(0 207 25)' }}>
				</i>Accepted Event | <i className="fas fa-circle mr-1" style={{ color: 'rgb(224, 224, 224)' }}>
				</i>Personal Event | <i className="fas fa-circle mr-1" style={{ color: 'rgb(251, 221, 115)' }}>
				</i>Requested Event {isClient && <span> | <i className="fas fa-circle mr-1" style={{ color: '#f0a89e' }} ></i>Declined Event  </span>}
			</div>
		</div>
	)
}

export default function GymCalendar () {
	const dispatch = useDispatch()
	const defaultView = (()=>{
		if ( window.innerWidth <= 600 ) return "day"
		return "week"
	})()

	const user = useCurrentUser()
	const isTime24Hour = Number(user.is_24_hour_time)

	const {status,events} = useEvents()
	console.log('all events',events)

	//Add fields required by react big calendar
	const formattedEvents = useMemo(
		() => events.map(
			event=>({
				...event,
				start:moment(`${event.occurrence_date.split(' ')[0]}T${event.start_time}`).toDate(),
				end:moment(`${event.occurrence_date.split(' ')[0]}T${event.end_time}`).toDate()
			})
		),
		[events]
	)
	console.log('formattedEvents',formattedEvents)

	const everyone = {
		label:'All Calendars',
		value:'everyone'
	}

	const {status:trainersStatus,trainers} = useGymTrainers()
	const {status:clientsStatus,clients} = useClients()

	const trainerOptions = trainers.map(trainer=>(
		{label:trainer.user_name,value:trainer.user_id_number}
	))
	const clientOptions = clients.map(client=>(
		{label:client.user_name,value:client.user_id_number}
	))

	const calendarOptions = [
		everyone,
		{
			label:'Trainers',
			options:trainerOptions
		},
		{
			label:'Clients',
			options:clientOptions
		}
	]

	const [date,setDate] = useState(new Date())
	
	useEffect(()=>{
		dispatch(setRange(nDaysAgo(date,45)))
		dispatch(getAllEventsInRange())
	},[date])

	const [calendars,setCalendars] = useState([everyone])
	const [showAvailabilities,setShowAvailabilities] = useState(true)

	const filters = (event)=>{
		const calendarKeys = calendars.map(({value})=>value)
		const matchEveryone = calendarKeys.includes('everyone')
		const trainersMatch = calendarKeys.filter(key=>{
			for(let i = 0; i < event.trainers.length; i++){
				if(event.trainers[i].user_id_number===key) return true
			}
			return false
		}).length>0 || calendarKeys.includes(event.trainer_id)
		calendarKeys.includes(event.trainer_id)
		const clientsMatch = calendarKeys.filter(k=>event.client_id_arr.includes(k)).length > 0
		if (!showAvailabilities&&event.event_type==='personal') return false
		return (
			matchEveryone
			|| trainersMatch
			|| clientsMatch
		)
	}

	const filteredEvents = useMemo(
		()=>formattedEvents.filter(filters),
		[formattedEvents,calendars,showAvailabilities]
	)
	console.log('filteredEvents',filteredEvents)

	const setCreator = useSetCreator()
	const setEditor = useSetEditor()
	const setViewer = useSetViewer()


	const handleSelectSlot = ({ action, start, end }) => {
		setCreator({
			show:true,
			date:dateToYMD(start),
			time:{
				start:dateToTimeObj(start,1),
				end:dateToTimeObj(end,1)
			}
		})
	}

	const handleSelectEvent =  e => {
		if (e.event_type !== "not_available") {
			setViewer({
				show:true,
				id:e.id
			})
			//setEditData(e);
			// workout/task/nutriton have event_id
			if (e.event_id&&['workout','task','nutrition'].includes(e.event_type)) {
				//handleExternalEvent(e)
			} else {
				//setShowOptionsModal(true)
			}
		}
	}

	const [isMoving,setIsMoving] = useState(false)
	const handleMoveEvent = ({start,end,event})=>{
		setIsMoving(true)
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			event_id:event.calendar_id,
			start_date:dateToAPIStandard(start),
			end_date:dateToAPIStandard(end),
			edit_series:'0',
			old_start_date:`${event.occurrence_date} ${event.start_time}`
		}

		dispatch(editCalendarEvent(payload)).then(()=>{
			setIsMoving(false)
		})
	}

	//for calendar, updates the date on toolbar click
	const handleNavigate = (date, view, navButton) => {
		setDate(date)
		if (navButton === "PREV" || navButton === "NEXT") {
			
		} else if (navButton === 'TODAY') {
			
		}
	}

	return (
		<div style={{padding:'8px'}}>
			<div className="d-flex align-items-center">
				<div style={{
					display:'flex',
					alignItems:'center',
					justifyContent:'center',
					width:'38px',
					height:'38px',
				}}>
					<i className="fa fa-calendar" />
				</div>
				<DatePicker
					onChange={setDate}
					selected={date}
					customInput={<Form.Control/>}
				/>
				<div style={{
					display:'flex',
					alignItems:'center',
					justifyContent:'center',
					width:'38px',
					height:'38px',
				}}>
					<i className="fa fa-users" />
				</div>
				<Select
					onChange={setCalendars}
					placeholder="Whose Calendar"
					options={calendarOptions}
					value={calendars}
					isMulti
					styles={{
						control: (provided) => ({
							...provided,
							minWidth: '300px', // Set the desired width here
						}),
					}}
				/>
				<Form.Check 
					onChange={e=>{
						setShowAvailabilities(e.target.checked)
					}}
					checked={showAvailabilities}
					id="hide-trainer-availabilities-check"
					label="Show When Trainers are Not Available"
					className="ml-2"
				/>
				{isMoving&&<Spinner animation="border" className="ml-2"/>}
			</div>
			<Legend/>
			<DragAndDropCalendar
				components={{
					//need to pass component as a function
					//so that we can access isTime24Hour variable
					event: (props)=>(
						<Event 
							is24HourTime={Boolean(isTime24Hour)}
							{...props}
						/>
					)
				}}
				date={date}
				formats={{
					timeGutterFormat:(date)=>{
						const timeObj = dateToTimeObj(date)
						return `${timeObj.hour}${timeObj.p}`
					},
					eventTimeRangeFormat: () => ""
				}}
				onEventDrop={handleMoveEvent}
				onSelectSlot={handleSelectSlot}
				onSelectEvent={handleSelectEvent}
				eventPropGetter={eventPropGetter}
				selectable="ignoreEvents"
				startAccessor="start"
				endAccessor="end"
				style={{background:'transparent'}}
				events={filteredEvents}
				localizer={localizer}
				defaultView={defaultView}
				views={["month", "week", "day", "agenda"]}
				onNavigate={handleNavigate}

			/>
			<Creator/>
			<Editor/>
			<Viewer/>
			<EventCopyModal/>
		</div>
	)
}